const ANALYTICS_ENVIRONMENTS = new Set(['production', 'preview']);
export const isAmplitudeEnabled = ({ environment, apiKey, }) => ANALYTICS_ENVIRONMENTS.has(environment) && !!apiKey;
//# sourceMappingURL=amplitude-environment.js.map